import section00 from './section-00-cover.locales'
import section01 from './section-01-situation.locales'
import section02 from './section-02-budget.locales'
import section03 from './section-03-patrimony.locales'
import section04 from './section-04-qualification.locales'
import section05 from './section-05-project.locales'
import section06 from './section-06-levers.locales'
import section07 from './section-07-preconisations.locales'
import section07_2 from './section-07-2-levier-financier.locales'
import section08 from './section-08-impact.locales'
import section09 from './section-09-rgpd.locales'
import section10 from './section-10-signature.locales'

export default {
  section00,
  section01,
  section02,
  section03,
  section04,
  section05,
  section06,
  section07,
  section07_2,
  section08,
  section09,
  section10,
}
